export default "__VITE_ASSET__MifUyN$l__"